module.exports = __webpack_public_path__ + "static/img/icon2-6.1ade8d19.png";